import downloadFlow from "../../../../frontend/components/core/modals/download-flow-modal";
import iconShare from "../../../../frontend/components/core/modals/icon-share-modal";
import auth from "../components/auth/auth-modal";
// not using absolute paths because Mocha complains

export const DOWNLOAD_FLOW = downloadFlow;
export const ICON_SHARE = iconShare;
export const AUTH = auth;

export const modalTypes = {
    DOWNLOAD_FLOW: "DOWNLOAD_FLOW",
    ICON_SHARE: "ICON_SHARE",
    AUTH: "AUTH"
};
